module.exports = __webpack_public_path__ + "img/we_6.64e6281e.svg";